import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Carousel from './Carousel'

const AirstreamSliderItem = ({ img, alt }) => (
  <img
    className='mx-auto'
    src={`/static/images/airstream/${img}.jpg`}
    alt={alt}
  />
)

class AirstreamCarousel extends Component {
  constructor () {
    super()
    this.state = { hasMounted: false }
  }
  componentDidMount () {
    this.setState({ hasMounted: true })
  }
  render () {
    const { slides, greaterThanSm } = this.props
    const { hasMounted } = this.state
    const slidesToShow = greaterThanSm ? 3 : 1

    if (!hasMounted) {
      return null
    }

    return (
      <Carousel
        extraClass={'airstream-carousel'}
        sliderOptions={{
          slidesToShow: slidesToShow,
          centerMode: greaterThanSm,
          infinite: false,
          initialSlide: 3,
          dots: true,
          autoplay: false
        }}
        slides={slides}
        slideRenderFn={AirstreamSliderItem}
      />
    )
  }
}

AirstreamCarousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      imagUrl: PropTypes.string,
      alt: PropTypes.string
    })
  ).isRequired,
  greaterThanSm: PropTypes.bool.isRequired
}

function mapStateToProps ({ browser }) {
  // note: important to _not_ return  browser.width here,
  // as it would force the component to re-render too often.
  // If we needed that level of accuracy we could use browser.innerWidth
  // inside the component, after ensuring we were in a browser.
  return {
    greaterThanSm: browser.greaterThan.sm
  }
}

export default connect(mapStateToProps)(AirstreamCarousel)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/AirstreamCarousel.js